import { render, staticRenderFns } from "./MergeContactSummary.vue?vue&type=template&id=a4fea3a6&scoped=true&"
import script from "./MergeContactSummary.vue?vue&type=script&lang=js&"
export * from "./MergeContactSummary.vue?vue&type=script&lang=js&"
import style0 from "./MergeContactSummary.vue?vue&type=style&index=0&id=a4fea3a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fea3a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4fea3a6')) {
      api.createRecord('a4fea3a6', component.options)
    } else {
      api.reload('a4fea3a6', component.options)
    }
    module.hot.accept("./MergeContactSummary.vue?vue&type=template&id=a4fea3a6&scoped=true&", function () {
      api.rerender('a4fea3a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/contact/components/MergeContactSummary.vue"
export default component.exports